import React from 'react';
import PropTypes from 'prop-types';
import { Link, makeResetStyles, makeStyles, mergeClasses, shorthands, tokens, } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';


const useAIGCDisclaimerStyles = makeStyles({
  marginLeft4: {
    marginLeft: '4px',
    ...shorthands.textDecoration('underline'),
  },
});

const useAIGCDisclaimerDefaultStyles = makeResetStyles({
  '&:focus': {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: tokens.colorStrokeFocus2,
  },
});

export const AIGCDisclaimer = (props) => {
  const {
    i18n,
  } = props;

  const classes = useAIGCDisclaimerStyles();
  const defaultClasses = useAIGCDisclaimerDefaultStyles();

  return (
    <div className="aigc-disclaimer">
      <MessageBar key="info" intent="info">
        <MessageBarBody>
          {i18n.getString(_TL_('Please ensure you review any newly created images carefully. It\'s your responsibility to ensure that the images do not infringe upon any third-party rights, including copyright or other intellectual property rights.'))}
          <Link
            className={mergeClasses(defaultClasses, classes.marginLeft4, 'aigc-info-text')}
            href="https://about.ads.microsoft.com/en-us/policies/intellectual-property-policies"
            target="_blank"
            aria-label={i18n.getString(_TL_('Learn more (opens in a new tab)'))}
          >
            {i18n.getString(_TL_('Learn more'))}
          </Link>
        </MessageBarBody>
      </MessageBar>
    </div>);
};


AIGCDisclaimer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

AIGCDisclaimer.defaultProps = {
};
